import React from "react";
import PageLayout from "../../../components/PageLayout";
import jeyedaProjectsHelp from "../../../content/help/jeyeda-projects.json";
import JeyedaProjectsTable from "./JeyedaProjectsTable";
import { fetchProjects } from "./JeyedaProjectsAPI";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";

export default function JeyedaProjects({ pageTitle = "Jeyeda Projects" }) {
  usePageTitle("Jeyeda Projects - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    onPageChange,
  } = usePageState({
    fetchFn: fetchProjects,
    filterFields: [
      (p) => p.id?.toString(),
      "label",
      (p) => p.owner?.username,
      (p) => p.collaborators?.map((c) => c.username).join(" "),
      (p) => p.dataSource?.id.toString(),
    ],
  });

  return (
    <div className="jeyeda-projects-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logoSrc="/img/Jeyeda_logo_no_text.png"
        description="Manager for Jeyeda Projects, allowing you to view, and organize your projects in one place"
        helpContent={jeyedaProjectsHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
        />

        <JeyedaProjectsTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </PageLayout>
    </div>
  );
}
